import React from 'react';

interface StatCardProps {
  number: string;
  title: string;
  description: string;
  backgroundColor?: string;
  textColor?: string;
  maxWidth?: string;
  numberSize?: string;
  titleSize?: string;
  descriptionSize?: string;
  padding?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  number,
  title,
  description,
  backgroundColor = '#5bb960',
  textColor = 'text-white',
  maxWidth = 'max-w-[300px]',
  numberSize = 'text-[80px] md:text-[148px]',
  titleSize = 'text-[20px] md:text-[35.5px]',
  descriptionSize = 'text-[14px] md:text-[17.9px]',
  padding = 'p-8 md:p-16'
}) => {
  return (
    <div 
      className={`flex flex-1 flex-col items-center ${padding}`}
      style={{ backgroundColor }}
    >
      <div className={`${maxWidth} text-center ${textColor}`}>
        <p className={`font-codec font-semibold ${numberSize} leading-[0.9]`}>
          {number} <p className={`${titleSize} ${textColor}`}>{title}</p>
        </p>
        <p className={`font-poppins ${descriptionSize} font-light pt-5`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default StatCard;